import {
  SAVE_SPOOL_FIT_UP,
  SAVE_SPOOL_FIT_UP_SUCCESS,
  SAVE_SPOOL_FIT_UP_FAILURE,
  SAVE_SPOOL_PREHEAT,
  SAVE_SPOOL_PREHEAT_SUCCESS,
  SAVE_SPOOL_PREHEAT_FAILURE,
  SAVE_SPOOL_WELDING,
  SAVE_SPOOL_WELDING_SUCCESS,
  SAVE_SPOOL_WELDING_FAILURE,
  SAVE_SPOOL_VT,
  SAVE_SPOOL_VT_SUCCESS,
  SAVE_SPOOL_VT_FAILURE,
  SAVE_SPOOL_NDT,
  SAVE_SPOOL_NDT_SUCCESS,
  SAVE_SPOOL_NDT_FAILURE,
  SAVE_SPOOL_COATING,
  SAVE_SPOOL_COATING_SUCCESS,
  SAVE_SPOOL_COATING_FAILURE,
  SAVE_SPOOL_ACCEPT,
  SAVE_SPOOL_ACCEPT_SUCCESS,
  SAVE_SPOOL_ACCEPT_FAILURE,
  CLEAR_SPOOL_TRACKER_SAVE_ERROR,
  FETCH_ALL_SPOOLS,
  FETCH_ALL_SPOOLS_SUCCESS,
  FETCH_ALL_SPOOLS_FAILURE,
  REGISTER_SPOOL_NCR,
  REGISTER_SPOOL_NCR_SUCCESS,
  REGISTER_SPOOL_NCR_FAILURE,
  FETCH_SPOOL_NCR_LIST,
  FETCH_SPOOL_NCR_LIST_SUCCESS,
  FETCH_SPOOL_NCR_LIST_FAILURE,
  FETCH_PROJECT_SPOOL_DASHBOARD,
  FETCH_PROJECT_SPOOL_DASHBOARD_SUCCESS,
  FETCH_PROJECT_SPOOL_DASHBOARD_FAILURE,
} from './types';

const initialState = {
  isSaving: false,
  savingStep: null,
  saveError: null,
  lastSaved: null,
  allSpools: [],
  allSpoolsLoading: false,
  allSpoolsError: null,
  ncrList: [],
  ncrListLoading: false,
  ncrListError: null,
  projectSpoolDashboard: null,
  projectSpoolDashboardLoading: false,
  projectSpoolDashboardError: null,
};

const saveStart = (state, step) => ({
  ...state,
  isSaving: true,
  savingStep: step,
  saveError: null,
});

const saveSuccess = (state, step, payload) => {
  const hasWrapped = payload && typeof payload === 'object' && 'response' in payload;
  const response = hasWrapped ? payload.response : payload;
  const request = hasWrapped ? payload.request : null;
  return {
    ...state,
    isSaving: false,
    savingStep: null,
    saveError: null,
    lastSaved: { step, at: Date.now(), response, request },
  };
};

const saveFailure = (state, step, error) => ({
  ...state,
  isSaving: false,
  savingStep: null,
  saveError: { step, message: error?.message || String(error || 'Save failed') },
});

export default function spoolsbaseReducer(state = initialState, action) {
  switch (action.type) {
    case SAVE_SPOOL_FIT_UP:
      return saveStart(state, 'fitUp');
    case SAVE_SPOOL_FIT_UP_SUCCESS:
      return saveSuccess(state, 'fitUp', action.payload);
    case SAVE_SPOOL_FIT_UP_FAILURE:
      return saveFailure(state, 'fitUp', action.error);

    case SAVE_SPOOL_PREHEAT:
      return saveStart(state, 'preheat');
    case SAVE_SPOOL_PREHEAT_SUCCESS:
      return saveSuccess(state, 'preheat', action.payload);
    case SAVE_SPOOL_PREHEAT_FAILURE:
      return saveFailure(state, 'preheat', action.error);

    case SAVE_SPOOL_WELDING:
      return saveStart(state, 'welding');
    case SAVE_SPOOL_WELDING_SUCCESS:
      return saveSuccess(state, 'welding', action.payload);
    case SAVE_SPOOL_WELDING_FAILURE:
      return saveFailure(state, 'welding', action.error);

    case SAVE_SPOOL_VT:
      return saveStart(state, 'vt');
    case SAVE_SPOOL_VT_SUCCESS:
      return saveSuccess(state, 'vt', action.payload);
    case SAVE_SPOOL_VT_FAILURE:
      return saveFailure(state, 'vt', action.error);

    case SAVE_SPOOL_NDT:
      return saveStart(state, 'ndt');
    case SAVE_SPOOL_NDT_SUCCESS:
      return saveSuccess(state, 'ndt', action.payload);
    case SAVE_SPOOL_NDT_FAILURE:
      return saveFailure(state, 'ndt', action.error);

    case SAVE_SPOOL_COATING:
      return saveStart(state, 'coating');
    case SAVE_SPOOL_COATING_SUCCESS:
      return saveSuccess(state, 'coating', action.payload);
    case SAVE_SPOOL_COATING_FAILURE:
      return saveFailure(state, 'coating', action.error);

    case SAVE_SPOOL_ACCEPT:
      return saveStart(state, 'accept');
    case SAVE_SPOOL_ACCEPT_SUCCESS:
      return saveSuccess(state, 'accept', action.payload);
    case SAVE_SPOOL_ACCEPT_FAILURE:
      return saveFailure(state, 'accept', action.error);

    case REGISTER_SPOOL_NCR:
      return saveStart(state, 'ncr');
    case REGISTER_SPOOL_NCR_SUCCESS:
      return saveSuccess(state, 'ncr', action.payload);
    case REGISTER_SPOOL_NCR_FAILURE:
      return saveFailure(state, 'ncr', action.error);

    case CLEAR_SPOOL_TRACKER_SAVE_ERROR:
      return { ...state, saveError: null };

    case FETCH_ALL_SPOOLS:
      return {
        ...state,
        allSpoolsLoading: true,
        allSpoolsError: null,
      };
    case FETCH_ALL_SPOOLS_SUCCESS:
      return {
        ...state,
        allSpoolsLoading: false,
        allSpoolsError: null,
        allSpools: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_ALL_SPOOLS_FAILURE:
      return {
        ...state,
        allSpoolsLoading: false,
        allSpoolsError: action.error?.message || String(action.error || 'Failed to load spools'),
        allSpools: [],
      };

    case FETCH_SPOOL_NCR_LIST:
      return {
        ...state,
        ncrListLoading: true,
        ncrListError: null,
      };
    case FETCH_SPOOL_NCR_LIST_SUCCESS:
      return {
        ...state,
        ncrListLoading: false,
        ncrListError: null,
        ncrList: Array.isArray(action.payload) ? action.payload : [],
      };
    case FETCH_SPOOL_NCR_LIST_FAILURE:
      return {
        ...state,
        ncrListLoading: false,
        ncrListError: action.error?.message || String(action.error || 'Failed to load NCR list'),
        ncrList: [],
      };

    case FETCH_PROJECT_SPOOL_DASHBOARD:
      return {
        ...state,
        projectSpoolDashboardLoading: true,
        projectSpoolDashboardError: null,
        projectSpoolDashboard: null,
      };
    case FETCH_PROJECT_SPOOL_DASHBOARD_SUCCESS:
      return {
        ...state,
        projectSpoolDashboardLoading: false,
        projectSpoolDashboardError: null,
        projectSpoolDashboard: action.payload && typeof action.payload === 'object' ? action.payload : null,
      };
    case FETCH_PROJECT_SPOOL_DASHBOARD_FAILURE:
      return {
        ...state,
        projectSpoolDashboardLoading: false,
        projectSpoolDashboardError: action.error?.message || String(action.error || 'Failed to load dashboard'),
        projectSpoolDashboard: null,
      };

    default:
      return state;
  }
}
